<template>
  <div>
    <data-modal
      v-if="selectedMessage"
      id="modal-message"
      :message="selectedMessage"
    />
    <filters
      v-if="statuses"
      :statuses="statuses"
    />
    <b-row>
      <b-col>
        <b-card>
          <b-card-actions
            ref="loadingCard"
            action-refresh
          >
            <div class="overflow-x-scroll">
              <b-table
                :fields="customsMessageFields"
                :items="customsMessages"
                :busy="loading"
                show-empty
                empty-text="No messages found or filters are not applied"
              >

                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle mr-1" />
                    <strong>Loading...</strong>
                  </div>
                </template>

                <template #cell(status)="data">
                  <b-badge
                    pill
                    variant="primary"
                  >
                    {{ data.item.status }}
                  </b-badge>
                </template>

                <template #cell(type)="data">
                  <b-badge
                    v-b-modal.modal-message
                    pill
                    variant="primary"
                    @click="selectedMessage = data.item"
                  >
                    {{ data.item.type }}
                  </b-badge>
                </template>

                <template #cell(at)="data">
                  <strong :class="data.item.class">{{ data.item.at | formatDate }}</strong>
                </template>

              </b-table>
            </div>
            <pagination :per-page="perPage" />
          </b-card-actions>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BTable,
  BRow,
  BCol,
  BCard,
  BBadge, BSpinner,
} from 'bootstrap-vue'
import shipmentModel from '@/views/shipments/shipmentModel'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import Filters from '@/views/customs_log/Filters.vue'
import Pagination from '@/layouts/components/Pagination/Pagination.vue'
import handleError from '@/views/components/errorHandler'
import DataModal from '@/views/customs_log/modals/dataModal.vue'
import { EventBus } from '@core/utils/utils'
import { searchQuery } from '@core/utils/filter'

export default {
  components: {
    BSpinner,
    DataModal,
    Pagination,
    Filters,
    BTable,
    BRow,
    BCol,
    BCard,
    BBadge,
    BCardActions,
  },
  data() {
    return {
      loading: false,
      selectedMessage: {},
      customsMessageFields: [
        'tracking_number',
        'document_number',
        'io',
        'type',
        'lrn',
        'mrn',
        'status',
        'at',
      ],
      page: 1,
      perPage: 30,
      sortBy: 'at',
      isSortDirDesc: true,
      filters: {},
      customsMessages: [],
      statuses: [],
    }
  },
  computed: {
    computedTableData() {
      return this.tableDataStore
    },
  },
  created() {
    EventBus.$on('updateData', this.handleUpdateData)
    EventBus.$on('updateFilters', this.handleUpdateFilters)
    EventBus.$on('pageChange', this.handlePageChange)
    this.fetchData()
    this.fetchStatuses()
  },
  beforeDestroy() {
    EventBus.$off('updateData', this.handleUpdateData)
    EventBus.$off('updateFilters', this.handleUpdateFilters)
    EventBus.$off('pageChange', this.handlePageChange)
  },
  methods: {
    handleUpdateData(data) {
      if (data) {
        this.tableDataStore = Object.values(data)
      }
    },
    handleUpdateFilters(data) {
      this.filters = data
      this.page = 1
      this.fetchData()
    },
    handlePageChange(newPage) {
      this.page = newPage
      this.fetchData()
    },
    fetchStatuses() {
      this.$http.get('/v1/customs/messages/statuses')
        .then(response => {
          this.statuses = response.data
        })
    },
    getShipment() {
      const cachedData = shipmentModel().getCachedShipment(this.$attrs.shipmentId)
      if (cachedData === null) {
        shipmentModel().getShipment(this.$attrs.shipmentId, this)
          .then(response => {
            shipmentModel().cacheShipment(response.data)
          })
      }
    },
    fetchData() {
      this.loading = true
      // Request
      this.filters = { ...this.filters, sortBy: this.sortBy, sortDesc: this.isSortDirDesc, page: this.page, perPage: this.perPage }
      this.$http.get(searchQuery('/v1/customs/messages', this.filters))
        .then(response => {
          this.$data.customsMessages = response.data.data
          EventBus.$emit('updateData', response.data.data)
          EventBus.$emit('updateMeta', response.data.meta)
        })
        .catch(error => {
          handleError(error, this.$toast)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>

</style>
